import React, { useEffect } from "react";

export function OpenApp(props) {
    useEffect(() => {
        window.location = "sportsboxclient://home";
    }, []);

    return <div></div>;
}